<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div class="card card-style">
    <div class="content p-2">
      <p>
        Ak sa chcete prihlásiť pod iným užívateľom. Musíte sa najprv odhlásiť. Po odhlásení, budú všetky dáta a súkromné informácie zmazané! Dáta, ktoré neboli zosynchronizované sa stratia!
      </p>
      <a href="#" data-menu="menu-logout" class="btn btn-m mt-2 mb-2 btn-full bg-red-dark rounded-sm text-uppercase font-900"><i class="i-loading fa fa-sync fa-spin me-3"></i>Odhlásiť</a>
    </div>
  </div>
</template>
